import React from 'react';
import './contact.css';
import { RiMailSendLine } from 'react-icons/ri';
import { RiTwitterLine } from 'react-icons/ri';
import { FiLinkedin } from 'react-icons/fi';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xih1v2d', 'template_yt7byea', form.current, 'Te6jRDZvpc3thRAr6')
      .then((result) => {
        console.log(result.text);
        toast.success("Mail sent successfully!!");
      }, (error) => {
        console.log(error.text);
        toast.error("Error in sending mail");
      });
    e.target.reset()
  };
  return (
      <section id='contact'>
        <h5>Get In Touch</h5>
        <h2>Contact Me</h2>
        <div className='container contact__container'>
          <div className='contact__options'>
            <article className='contact__option'>
              <RiMailSendLine className='contact__option-icon' />
              <h4>Email</h4>
              <h5>"luckyvid15@gmail.com"</h5>
              <a href='mailto:luckyvid15y@gmail.com'>Send a message</a>
            </article>

            <article className='contact__option'>
              <RiTwitterLine className='contact__option-icon-t' />
              <h4>Twitter</h4>
              <h5>"LuckYadav15@twitter.com"</h5>
              <a href='twitter.com/LuckYadav15'>Send a message</a>
            </article>

            <article className='contact__option'>
              <FiLinkedin className='contact__option-icon' />
              <h4>LinkedIn</h4>
              <h5>"Lucky Yadav"</h5>
              <a href='https://www.linkedin.com/in/lucky-yadav-19b403232/'>Send a message</a>
            </article>
          </div>
          {/* End of CONTACT OPTIONS */}
          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder='Your Full Name' required />
            <input type="email" name='email' placeholder='Your Email' required />
            <textarea name='message' rows="7" placeholder='Your Message' required></textarea>
            <button type='submit' className='btn btn-primary'>Send Message</button>
          </form>
        </div>
        <ToastContainer position='top-center' />
      </section>
  )
}

export default Contact